import React from 'react';
import { Link } from 'react-router-dom';

const LegalNotice = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">&larr; Volver al inicio</Link>
        <h1 className="legal-title">Aviso Legal</h1>
        <p className="legal-date">
          <em>&Uacute;ltima actualizaci&oacute;n: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
        </p>

        <section className="legal-section">
          <h2>1. Datos identificativos del titular</h2>
          <p>
            En cumplimiento del art&iacute;culo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la
            Sociedad de la Informaci&oacute;n y de Comercio Electr&oacute;nico (LSSI-CE), se informa al
            usuario de los datos del titular de este sitio web:
          </p>
          <ul>
            <li><strong>Titular:</strong> Myntar S.L. PENDIENTE NIF</li>
            <li><strong>NIF/CIF:</strong> PENDIENTE</li>
            <li><strong>Domicilio social:</strong> Calle Lorenzo Ferreira 26, C&oacute;rdoba, Espa&ntilde;a</li>
            <li><strong>Datos registrales:</strong> EN PROCESO DE INSCRIPCIÓN EN EL REGISTRO MERCANTIL</li>
            <li><strong>Email:</strong> contact@myntar.tech</li>
            <li><strong>Sitio web:</strong> www.myntar.tech</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. Objeto del sitio web</h2>
          <p>
            Este sitio web tiene como finalidad informar sobre los productos y servicios de Myntar,
            plataforma de avatares inteligentes con IA conversacional avanzada para los sectores de
            retail, hosteler&iacute;a, turismo, educaci&oacute;n y cultura, as&iacute; como facilitar
            el contacto con los usuarios interesados.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Condiciones de uso</h2>
          <p>
            El acceso y uso de este sitio web atribuye la condici&oacute;n de usuario e implica la
            aceptaci&oacute;n plena y sin reservas de todas y cada una de las disposiciones incluidas
            en este Aviso Legal, as&iacute; como en la <Link to="/privacidad">Pol&iacute;tica de
            Privacidad</Link>, la <Link to="/cookies">Pol&iacute;tica de Cookies</Link> y los <Link
            to="/terminos">T&eacute;rminos y Condiciones</Link> publicados en el momento del acceso.
          </p>
          <p>
            El usuario se compromete a hacer un uso adecuado de los contenidos y servicios ofrecidos
            a trav&eacute;s de este sitio web y a no emplearlos para:
          </p>
          <ul>
            <li>Realizar actividades il&iacute;citas o contrarias a la buena fe y al ordenamiento jur&iacute;dico</li>
            <li>Difundir contenidos de car&aacute;cter racista, xen&oacute;fobo, pornogr&aacute;fico, de
            apolog&iacute;a del terrorismo o atentatorio contra los derechos humanos</li>
            <li>Provocar da&ntilde;os en los sistemas f&iacute;sicos o l&oacute;gicos de Myntar, de sus
            proveedores o de terceros</li>
            <li>Intentar acceder y, en su caso, utilizar las cuentas de correo electr&oacute;nico de otros
            usuarios y modificar o manipular sus mensajes</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Propiedad intelectual e industrial</h2>
          <p>
            Todos los contenidos del sitio web, incluyendo, a t&iacute;tulo enunciativo pero no
            limitativo, textos, fotograf&iacute;as, gr&aacute;ficos, im&aacute;genes, iconos, tecnolog&iacute;a,
            software, enlaces y dem&aacute;s contenidos audiovisuales o sonoros, as&iacute; como su
            dise&ntilde;o gr&aacute;fico y c&oacute;digos fuente, son propiedad intelectual de Myntar
            o de terceros que han autorizado su uso, sin que puedan entenderse cedidos al usuario
            ninguno de los derechos de explotaci&oacute;n reconocidos por la normativa vigente en
            materia de propiedad intelectual sobre los mismos.
          </p>
          <p>
            Las marcas, nombres comerciales o signos distintivos son titularidad de Myntar o de
            terceros, sin que el acceso al sitio web pueda atribuir al usuario derecho alguno sobre
            las citadas marcas, nombres comerciales y/o signos distintivos.
          </p>
          <p>
            Queda expresamente prohibida la reproducci&oacute;n, distribuci&oacute;n, comunicaci&oacute;n
            p&uacute;blica, puesta a disposici&oacute;n o transformaci&oacute;n total o parcial de los
            contenidos de este sitio web sin la autorizaci&oacute;n expresa y por escrito de Myntar.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Exclusi&oacute;n de responsabilidad</h2>
          <p>
            Myntar no se hace responsable, en ning&uacute;n caso, de los da&ntilde;os y perjuicios
            de cualquier naturaleza que pudieran ocasionarse por:
          </p>
          <ul>
            <li>La falta de disponibilidad o accesibilidad del sitio web</li>
            <li>La falta de veracidad, exactitud, exhaustividad y/o actualidad de los contenidos</li>
            <li>La existencia de virus u otros elementos da&ntilde;inos en los contenidos que pudieran
            causar alteraciones en los sistemas inform&aacute;ticos, documentos electr&oacute;nicos
            o datos de los usuarios</li>
            <li>El uso il&iacute;cito, negligente, fraudulento o contrario a este Aviso Legal que
            haga el usuario del sitio web</li>
            <li>La falta de licitud, calidad, fiabilidad, utilidad y disponibilidad de los servicios
            prestados por terceros y puestos a disposici&oacute;n de los usuarios a trav&eacute;s
            del sitio web</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Enlaces a terceros</h2>
          <p>
            Este sitio web puede contener enlaces a sitios web de terceros. Myntar no se hace
            responsable del contenido, pol&iacute;ticas de privacidad o pr&aacute;cticas de los
            sitios web de terceros. Le recomendamos leer los t&eacute;rminos y condiciones y la
            pol&iacute;tica de privacidad de cada sitio web de terceros que visite.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Protecci&oacute;n de datos personales</h2>
          <p>
            Myntar cumple con la normativa vigente en materia de protecci&oacute;n de datos personales,
            en particular con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo (RGPD)
            y la Ley Org&aacute;nica 3/2018, de 5 de diciembre, de Protecci&oacute;n de Datos Personales
            y garant&iacute;a de los derechos digitales (LOPD-GDD).
          </p>
          <p>
            Para m&aacute;s informaci&oacute;n sobre c&oacute;mo tratamos sus datos personales, consulte
            nuestra <Link to="/privacidad">Pol&iacute;tica de Privacidad</Link>.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Modificaciones</h2>
          <p>
            Myntar se reserva el derecho de realizar las modificaciones que considere oportunas en
            este Aviso Legal, sin necesidad de previo aviso. Dichas modificaciones podr&aacute;n
            realizarse a trav&eacute;s de su sitio web por cualquier forma admisible en derecho y
            ser&aacute;n de obligado cumplimiento durante el tiempo en que se encuentren publicadas
            y hasta que no sean modificadas v&aacute;lidamente por otras posteriores.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Legislaci&oacute;n aplicable y jurisdicci&oacute;n</h2>
          <p>
            La relaci&oacute;n entre Myntar y el usuario se regir&aacute; por la normativa espa&ntilde;ola
            vigente. Para la resoluci&oacute;n de cualquier controversia que pudiera derivarse del
            acceso o uso de este sitio web, las partes se someten a los Juzgados y Tribunales de
            C&oacute;rdoba (Espa&ntilde;a), con renuncia expresa a cualquier otro fuero que pudiera
            corresponderles, salvo que la legislaci&oacute;n aplicable disponga otra cosa.
          </p>
        </section>

        <div className="legal-links-section">
          <p>Ver tambi&eacute;n:</p>
          <ul>
            <li><Link to="/privacidad">Pol&iacute;tica de Privacidad</Link></li>
            <li><Link to="/cookies">Pol&iacute;tica de Cookies</Link></li>
            <li><Link to="/terminos">T&eacute;rminos y Condiciones</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
